'use client';

import { useState, useEffect } from 'react';
import { useDevice } from '@/app/lib/contexts/DeviceContext';
import {
  getPWAPlatform,
  isPWAInstalled,
  canShowInstallPrompt,
  dismissInstallPrompt,
  type PWAPlatformInfo
} from '@/app/utils/pwa-utils';

interface UsePWAReturn {
  // Install prompt state
  showInstallBanner: boolean;
  isInstalled: boolean;
  platform: PWAPlatformInfo;

  // Install actions
  dismissBanner: () => void;
}

export function usePWA(): UsePWAReturn {
  const { isMobile } = useDevice();
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [platform] = useState<PWAPlatformInfo>(() => getPWAPlatform());

  useEffect(() => {
    // Check if already installed
    const installed = isPWAInstalled();
    setIsInstalled(installed);
    console.log(`[PWA Debug] PWA installed status: ${installed}`);

    // Show install banner if criteria met
    const canShow = canShowInstallPrompt(isMobile);
    console.log(`[PWA Debug] Can show install banner: ${canShow}`);

    if (canShow && !installed) {
      console.log('[PWA Debug] Showing install banner immediately');
      setShowInstallBanner(true);
    }
  }, [isMobile]);



  const dismissBanner = () => {
    dismissInstallPrompt();
    setShowInstallBanner(false);
  };


  return {
    // Install state
    showInstallBanner,
    isInstalled,
    platform,

    // Install actions
    dismissBanner,
  };
}